import { CmsValue } from 'core/type/BootstrapConfig.types';
import { SelectedOfferState } from 'component/page/detail/store/availabilityDEPRECATED.types';
import { createSelector, Dispatch } from '@reduxjs/toolkit';
import { selectIsShowDateNotAvailableNotification, selectOfferSelected } from 'component/page/detail/store/availabilitySelectorIndex';
import { selectCmsFromBootstrap, selectExperimentsFromBootstrap, selectFeatureBehaviorFromBootstrap } from 'store/slice/bootstrap';
import { availabilityInitialState, setOffer } from 'component/page/detail/store/availabilityIndex';
import { Offer } from 'gql/autogen/Offer';
import { isB } from 'core/window/bootstrapConfig';
import { ExperimentId } from 'core/type/ExperimentId';
import { showNotification } from 'store/slice/notification';

interface StateProps {
    cms: CmsValue;
    selectedOffer: SelectedOfferState;
    updateShowMoreButton: boolean;
    isShowDateNotAvailableNotification: boolean;
    isContinueYourBooking: boolean;
    isDetailPageForSimCardEnabled: boolean;
}

interface DispatchProps {
    resetSelectedOfferCard: () => void;
    setShowContinueYourBookingNotification: (notificationText: string) => void;
}

interface OwnProps {
    offers: Offer[];
    supplier: number;
}

export type Props = StateProps & DispatchProps & OwnProps;

export const mapStateToProps = createSelector(
    selectCmsFromBootstrap,
    selectOfferSelected,
    selectExperimentsFromBootstrap,
    selectIsShowDateNotAvailableNotification,
    selectFeatureBehaviorFromBootstrap,
    (cms, selectedOffer, experiments, isShowDateNotAvailableNotification, featureBehaviors): StateProps => {
        return {
            cms,
            selectedOffer,
            updateShowMoreButton: isB(ExperimentId.ACT_4657, experiments),
            isShowDateNotAvailableNotification,
            isContinueYourBooking: featureBehaviors.ContinueYourBooking,
            isDetailPageForSimCardEnabled: featureBehaviors.DetailPageForSimCard,
        };
    },
);

export const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
    resetSelectedOfferCard: () => {
        dispatch(setOffer(availabilityInitialState.selectedOffer));
    },
    setShowContinueYourBookingNotification: (notificationText: string) => {
        dispatch(showNotification(notificationText));
    },
});
